module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("I suspect that I am attracted to Bonhoeffer for the same reasons most American Christians are. According to Keith L. Johnson, Bonhoeffer “just seems to see things differently than the rest of us, as if he instinctively knows something about God that most of us spend our lives seeking but can never quite find.” These words speak for me as well. I am also drawn to Bonhoeffer because he cultivated the space between the worlds of the academy and the church in a way that, to quote Johnson again, made him “"), _c('i', [_vm._v("more")]), _vm._v(" rather than less faithful as a result of living with this tension.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#rfna-1",
      "id": "fna-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I would like to acknowledge those who allow and encourage me to explore Bonhoeffer’s legacy in the liminal space between academy and church: colleagues at Rhodes College, members of Idlewild Presbyterian Church, and friends who wonder why I spend so much time thinking about someone who has been dead nearly eighty years. These include Oscar Carr, Stephen and Mary McIntosh, Casey West, Don McClure, Margaret Burnett, Philip Taylor, and Tim Huebner, among many others.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("My family was extraordinarily supportive during the writing of this book, as they always are. As I rushed to complete it in the early weeks of 2018, they kept asking if I was “almost finished.” Now that I am, I must admit that, given the nature of this study, it does not seem finished at all. As those who are concerned about the direction of our nation continue to try to make sense of what is happening around them, Bonhoeffer will continue to be our conversation partner. "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("I hope that what I have written about the role of Bonhoeffer in our public discourse will have a positive impact on the role he plays in that conversation.")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("More than anyone else, Trevor Thompson deserves credit for this book. He read a piece I wrote about Bonhoeffer in the "), _c('i', [_vm._v("Huffington Post")]), _vm._v(" shortly after the 2016 election and saw the germ of a book. To be honest, I did not; but Trevor persisted and eventually convinced me that I had something to say that might advance the conversation. He was right, and I am thankful for his gentle persuasion, as well as his strong encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, I would like to dedicate this book to the men of the Tuesday noon group. Keep coming back.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7eb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 72
// module chunks = 0